
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_f8g6q_1vw03_145",
  "embedded": "awsui_embedded_f8g6q_1vw03_177",
  "tokens": "awsui_tokens_f8g6q_1vw03_210"
};
  